import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CALL_SIGNAL_LABELS, CallQuality, INITIAL_CALL_QUALITY } from 'src/app/models/call-quality.model';

/**
 * Signal bars for the browser leg of a call, plus a line of text when the connection is reconnecting
 * or the network is degrading the audio. Purely presentational: CallQualityService does the reading.
 */
@Component({
  selector: 'app-call-signal-indicator',
  templateUrl: './call-signal-indicator.component.html',
  styleUrls: ['./call-signal-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallSignalIndicatorComponent {
  @Input() quality: CallQuality | null = INITIAL_CALL_QUALITY;
  /** Bars only, for the minimized call bar. */
  @Input() compact = false;

  readonly bars = [1, 2, 3];

  get current(): CallQuality {
    return this.quality ?? INITIAL_CALL_QUALITY;
  }

  get label(): string {
    return this.current.reconnecting ? 'Reconnecting…' : CALL_SIGNAL_LABELS[this.current.level];
  }

  /** How many bars are lit: 3 good, 2 fair, 1 poor, none while unknown or reconnecting. */
  get litBars(): number {
    if (this.current.reconnecting) {
      return 0;
    }
    return { unknown: 0, good: 3, fair: 2, poor: 1 }[this.current.level];
  }

  get unstable(): boolean {
    return !this.current.reconnecting && this.current.networkWarnings.length > 0;
  }
}
